import React, { useEffect } from "react";
import icons from "../assets/variables/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardFooter,
} from "reactstrap";

export function DataImgsHeaderEvennements({ crmCount }) {
  /*const crmsSoldDeb = useSelector((state) => state.crmReducer.crmsSoldDeb);
  const crmsSoldCred = useSelector((state) => state.crmReducer.crmsSoldCred);
  //console.log("crmsSoldDeb", crmsSoldDeb);
  // console.log("crmsSoldCred", crmsSoldCred);
  // useEffect(() => {}, [crmsSoldDeb || crmsSoldCred]);

  function AffcrmsolDeb() {
    if (crmCount > 0) {
      if (crmsSoldDeb - crmsSoldCred > 0) {
        return (crmsSoldDeb - crmsSoldCred).toFixed(2);
      } else {
        return "0";
      }
    } else {
      return "0";
    }
  }

  function AffcrmsolCred() {
    if (crmCount > 0) {
      if (crmsSoldCred - crmsSoldDeb > 0) {
        return (crmsSoldCred - crmsSoldDeb).toFixed(2);
      } else {
        return "0";
      }
    } else {
      return "0";
    }
  }*/
  return (
    <div className="img-header-container flex">
      <Col lg="3" md="6">
        <Card className="card-stats">
          <CardBody className="testCard">
            <Row>
              <Col xs="5">
                <div className="info-icon text-center icon-success">
                  <i className="far fa-user"></i>
                </div>
              </Col>
              <Col xs="7">
                <div className="numbers">
                  <p className="card-category">Nb Evennements Actifs</p>
                  <CardTitle tag="h4">{crmCount}</CardTitle>
                </div>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <hr />
            <div className="stats">
              <i className="tim-icons icon-sound-wave" />
            </div>
          </CardFooter>
        </Card>
      </Col>

      {}
    </div>
  );
}
